import type { Site } from '@hotjar/webapp/domains/common/feature';
import { isAllowed } from '@hotjar/webapp/domains/common/feature';
import { useCurrentSite } from '@hotjar/site';

/**
 * Looks for a given feature on ono either the current plan, site, organization, or account.
 * Passing in an optional site will use that site rather then the currently active site.
 *
 * Usage:
 * const isSlackIntegrationAllowed = useFeature('settings.slack_integration', siteObject);
 *
 * @param {string} feature Name of the feature flag to lookup.
 * @param {object} [site] An optional site object to look for the feature in.
 * @deprecated use useFeatureFlag (from @hotjar/feature-flags) for checking feature flags
 * and useGate (from @hotjar/allowances) for checking gates. Note this hook has been extracted
 * to @hotjar/feature-flags only to enable existing usages to maintain the same functionality
 * when extracted from legacy.
 */
export function useFeature(feature: string, site?: Site): boolean {
  const { data: currentSite } = useCurrentSite();

  if (!site && !currentSite) {
    return false;
  }

  if (site) {
    return isAllowed(feature, site);
  }

  return isAllowed(feature, currentSite ?? null);
}
